import urlHelper from 'src/helpers/urlHelper'
import { isSunshineWebsite } from '../../helpers/white-label-helper'

export interface SettingsMenuTarget {
  path: string
  isRedirect: boolean
}

/**
 * Sunshine users stay on the CMS domain and open the in-CMS account page in the current tab.
 * Every other domain keeps opening the ERP settings in a new tab.
 */
export const getSettingsMenuTarget = ({
  workspaceId,
  erpSettingsUrl
}: {
  workspaceId?: string | null
  erpSettingsUrl: string
}): SettingsMenuTarget => {
  if (isSunshineWebsite() && workspaceId) {
    return { path: urlHelper.getAccountPageUrl(workspaceId), isRedirect: false }
  }

  return { path: erpSettingsUrl, isRedirect: true }
}
